module.exports = __webpack_public_path__ + "static/media/individualRequest.edc38976.svg";